import { type FormValidateInput } from '@mantine/form';
import { validateCalculationRule, validateCommission } from '../../../lib/utils';
import { traderNameErrorText, traderNameRegex } from '../constants';
import { type ActivateTraderRequest } from '../../../model';

export const validate: FormValidateInput<ActivateTraderRequest> = {
    traderName: {
        value: (value) => {
            if (!value?.trim()) {
                return 'Обязательное поле';
            }

            return traderNameRegex.test(value) ? null : traderNameErrorText;
        },
    },
    commission: {
        value: validateCommission,
    },
    calculationRules: validateCalculationRule,
};
